module.exports = {
    "source_code": "HLXEMS",
    "site_id": "info.ep.jhu.edu",
    "title": "Johns Hopkins University",
    "tfn": "888-719-6340",
    "url": "https://info.ep.jhu.edu",
    "gtm_code": "GTM-5ZWSVLV",
}